module.exports = __webpack_public_path__ + "img/kaz.740ef4bf.svg";